<template>
  <div class="app-tabs-slider-wrapper" @click.stop>
    <div class="swiper-container app-tabs-slider" :class="`app-tabs-slider_${this._uid} app-tabs-slider_${type}`">
      <div class="swiper-wrapper" v-if="isLinks">
        <router-link :to="{ name: tab.routeName }"
                     class="swiper-slide"
                     v-for="tab in tabs"
                     :key="tab.routeName"
                     v-show="!tab.disabled"
        >
          {{ tab.name }}
        </router-link>
      </div>
      <div v-else class="swiper-wrapper">
        <span
          :class="['swiper-slide', { active: index === activeTabIndex }]"
          v-for="(tab, index) in tabs"
          :key="tab.routeName"
          @click.stop="() => {activeTabIndex = index, $emit('switch', tab, index)}"
        >
          {{ tab.name }}
        </span>
      </div>
    </div>
    <div class="app-tabs-slider__prev" :class="`app-tabs-slider__prev_${this._uid}`">
      <svg width="9" height="17" viewBox="0 0 9 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 16L2 8.5L8 1" stroke="currentColor" stroke-width="2"/>
      </svg>
    </div>
    <div class="app-tabs-slider__next" :class="`app-tabs-slider__next_${this._uid}`">
      <svg width="9" height="17" viewBox="0 0 9 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 16L7 8.5L1 1" stroke="currentColor" stroke-width="2"/>
      </svg>
    </div>
  </div>
</template>

<script>
import Swiper, { Navigation, Pagination } from 'swiper'

Swiper.use([Navigation, Pagination])

export default {
  name: 'app-tabs-slider',
  props: {
    // types
    // main, secondary (для второго уровня вкладок)
    type: {
      type: String,
      default: 'main'
    },
    tabs: {
      type: Array,
      default: () => [
        { name: 'Вкладка 1', routeName: 'tabRoute01', disabled: false },
        { name: 'Вкладка 2', routeName: 'tabRoute02', disabled: false }
      ]
    },
    spaceBetween: {
      type: Number,
      default: 0
    },
    breakpoints: {
      type: Object,
      default: () => ({})
    },
    isLinks: {
      type: Boolean,
      default: true
    },
    propActiveTabIndex: {
      type: Number,
      default: 0
    }
  },
  computed: {},
  methods: {},
  mounted () {
    // eslint-disable-next-line no-unused-vars
    const appTabsSlider = new Swiper(`.app-tabs-slider_${this._uid}`, {
      slidesPerView: 'auto',
      spaceBetween: this.spaceBetween,
      watchOverflow: true,
      navigation: {
        prevEl: `.app-tabs-slider__prev_${this._uid}`,
        nextEl: `.app-tabs-slider__next_${this._uid}`
      }
    })
  },
  data () {
    return {
      activeTabIndex: this.propActiveTabIndex
    }
  }
}
</script>

<style lang="scss" scoped>

.app-tabs-slider-wrapper {
  position: relative;
  display: flex;
  align-items: center;

  &:after {
    content: '';
    position: absolute;
    top: auto;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 4px;
    background: $color__smoke;
  }
}

.app-tabs-slider {
  width: 100%;
  margin-right: 62px;

  &__prev,
  &__next {
    position: absolute;
    z-index: 2;
    top: 0;
    left: auto;
    right: 0;
    height: 100%;
    color: $color_second-light;
    transition: .3s;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    user-select: none;

    &.swiper-button-lock {
      display: none;
    }

    @media screen and (min-width: $hover_enable_width) {
      &:hover {
        color: $color_main;
      }

      &.swiper-button-disabled {
        &:hover {
          color: $color_deactive;
        }
      }
    }
  }

  &__prev {
    right: 9px; // next button width
    margin-right: 20px;
  }

  &_secondary {
    .swiper-slide:after {
      background: $color_main;
    }
  }
}

.swiper-slide {
  position: relative;
  width: auto;
  cursor: pointer;
  color: $color__brown;
  transition: color .3s;
  padding-bottom: 8px;

  &:after {
    content: '';
    position: absolute;
    top: auto;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 4px;
    background: $color__orange;
    transition: .3s;
    transform: scaleX(0);
  }

  &.router-link-active {
    color: $color_second-dark;

    &:after {
      transform: scaleX(1);
    }
  }

  &.active {
    color: $color_second-dark;

    &:after {
      transform: scaleX(1);
    }
  }

  @media screen and (min-width: $hover_enable_width) {
    &:hover {
      color: $font_color_main;
    }
  }
}
</style>
